import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PatrolCommunitySourceId } from '../models/patrol-community-source.model';
import { PatrolCommunitySourcesService } from '../services/patrol-community-sources.service';

export function patrolSourceEnabledGuard(
  sourceId: PatrolCommunitySourceId,
): CanActivateFn {
  return async () => {
    const sources = inject(PatrolCommunitySourcesService);
    const router = inject(Router);

    await sources.whenReady();

    if (!sources.isGloballyEnabled(sourceId)) {
      return router.createUrlTree(['/setup']);
    }

    if (sources.isEnabled(sourceId)) {
      return true;
    }

    return router.createUrlTree(['/setup']);
  };
}
